import * as requestFromServer from "./serviceProviderDashboardApis";
import Actions from "../../actions";

// service provider dashboard -> get service provider dashboard index api
export const getServiceProviderDashboardIndexAction = (setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getServiceProviderDashboardIndex();
  if (response) {
    dispatch(Actions.createAction(Actions.GET_SERVICE_PROVIDER_DASHBOARD_INDEX_LIST, {serviceProviderDashboardIndex:response}))
    setLoading(false);
    return response;
  }
  else {
    setLoading(false)
    return null
  }
};

// service provider dashboard -> get service provider dashboard order metrics api
export const getServiceProviderDashboardOrderMetricsAction = (setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getServiceProviderDashboardOrderMetrics();
  if (response) {
    dispatch(Actions.createAction(Actions.GET_SERVICE_PROVIDER_DASHBOARD_ORDER_METRICS_LIST, {serviceProviderDashboardOrderMetrics:response}))
    setLoading(false);
    return response;
  }
  else {
    setLoading(false)
    return null
  }
};

// service provider dashboard -> get service provider dashboard sales metrics api
export const getServiceProviderDashboardSalesMetricsAction = (setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getServiceProviderDashboardSalesMetrics();
  if (response) {
    dispatch(Actions.createAction(Actions.GET_SERVICE_PROVIDER_DASHBOARD_SALES_METRICS_LIST, {serviceProviderDashboardSalesMetrics:response}))
    setLoading(false);
    return response;
  }
  else {
    setLoading(false)
    return null
  }
};